export { Code } from "@mantine/core";
export type { CodeProps } from "@mantine/core";
export { getCodeOverrides } from "./Code.styled";
